import { PermissionEffects } from './permission/permission.effects';
import { ViewsEffects } from './views/views.effects';

export const APP_EFFECTS = [PermissionEffects, ViewsEffects];
